import { Missing } from 'components/atoms/Missing';

import { PagePanel } from '../PagePanel';

export const NotFoundPanel = () => (
  <PagePanel w="full" flexGrow={0} textAlign="center">
    <Missing />
  </PagePanel>
);
